import * as vehicleTypes from 'inventory-listing/actions/listingUsedActionTypes.js';

export default function vehiclesReducer(state = [], action) {
    switch (action.type) {
        case vehicleTypes.ADD_VEHICLES:
            return action.vehicles;

        case vehicleTypes.SET_VEHICLES:
            return action.vehicles;

        case vehicleTypes.LOAD_VEHICLES:
            return [...state, ...action.vehicles];

        default:
            return state;
    }
}
